import React from 'react';
import PropTypes from 'prop-types';

import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import yup from 'src/utils/yup';
import { useFormik } from 'formik';

import Button from 'src/component/UI/Button';
import { useTranslation } from 'src/i18n';

export default function InviteUserModal (props) {
  const { t } = useTranslation();

  const handleSubmit = (values) => {
    props.handleSubmit(values);
    formik.resetForm();
  };

  const validationSchema = yup.object({
    email: yup
      .string(t('validation.enterEmail'))
      .email(t('validation.validEmail'))
      .required(t('validation.emailRequired')),
    firstName: yup
      .string(t('users.firstName'))
      .required(t('validation.firstNameRequired')),
    lastName: yup
      .string(t('users.lastName'))
      .required(t('validation.lastNameRequired')),
  });

  const formik = useFormik({
    initialValues: {
      email: '',
      firstName: '',
      lastName: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby='invite-user-modal-title'
    >
      <div className='modal invite-user-modal'>
        <h2 id='invite-user-modal-title'>{t('users.inviteToFacility')}</h2>
        <form onSubmit={formik.handleSubmit}>
          <TextField
            fullWidth
            id="firstName"
            name="firstName"
            label={t('users.firstName')}
            type="text"
            value={formik.values.firstName}
            onChange={formik.handleChange}
            error={formik.touched.firstName && Boolean(formik.errors.firstName)}
            helperText={formik.touched.firstName && formik.errors.firstName}
          />
          <TextField
            fullWidth
            id="lastName"
            name="lastName"
            label={t('users.lastName')}
            type="text"
            value={formik.values.lastName}
            onChange={formik.handleChange}
            error={formik.touched.lastName && Boolean(formik.errors.lastName)}
            helperText={formik.touched.lastName && formik.errors.lastName}
          />
          <TextField
            fullWidth
            id="email"
            name="email"
            label={t('users.email')}
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />

          <div className='button-bar'>
            <Button variant="contained" fullWidth onClick={props.handleClose} >{t('common.cancel')}</Button>
            <Button color="primary" variant="contained" fullWidth type="submit" cta>{t('users.inviteUser')}</Button>
          </div>
        </form>
      </div>
    </Modal>
  );
}

InviteUserModal.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

InviteUserModal.defaultProps = {
};
